var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _rect, _path, _path2, _path3, _path4, _rect2, _path5, _path6, _path7, _path8, _path9, _path10, _rect3, _rect4, _path11, _path12, _path13, _path14, _path15, _path16, _rect5, _rect6, _path17, _path18, _path19, _path20, _path21, _path22, _rect7, _rect8, _path23, _path24, _path25, _path26, _path27, _path28, _rect9, _rect10, _path29, _path30, _path31, _path32, _path33, _path34, _rect11, _rect12, _path35, _path36, _path37, _path38, _path39, _path40, _rect13, _path41;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCollectiveContrastShower(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 291,
    height: 149,
    viewBox: "0 0 291 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 96.5,
    r: 1.5,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 22.5,
    r: 1.5,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 289.5,
    cy: 131.5,
    r: 1.5,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 128.5,
    r: 1.5,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 275.5,
    cy: 36.5,
    r: 1.5,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 247.5,
    cy: 97.5,
    r: 1.5,
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.04,
    width: 216,
    height: 4,
    rx: 2,
    transform: "matrix(1 0 0 -1 36 149)",
    fill: "#24284E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M238 14.5L254 8.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M263.5 74L281 76.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49 8.5L64 16",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 63.5L24 65",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 54.7764,
    y: 37.2891,
    width: 48,
    height: 48,
    rx: 24,
    transform: "rotate(-3 54.7764 37.2891)",
    fill: "#57A1F7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6972 71.7167C85.7505 72.7349 84.9684 73.6036 83.9501 73.6569C82.9319 73.7103 82.0633 72.9281 82.0099 71.9099C81.9133 70.0663 83.6844 68.587 83.6844 68.587C83.6844 68.587 85.6005 69.8731 85.6972 71.7167Z",
    fill: "#24284E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M79.245 72.0565C79.2984 73.0747 78.5162 73.9434 77.498 73.9968C76.4798 74.0501 75.6111 73.268 75.5578 72.2498C75.4611 70.4062 77.2323 68.9268 77.2323 68.9268C77.2323 68.9268 79.1484 70.2129 79.245 72.0565Z",
    fill: "#24284E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2196 65.7968C75.273 66.815 74.4908 67.6837 73.4726 67.737C72.4544 67.7904 71.5857 67.0082 71.5324 65.99C71.4357 64.1464 73.2069 62.6671 73.2069 62.6671C73.2069 62.6671 75.123 63.9531 75.2196 65.7968Z",
    fill: "#24284E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1327 65.4354C82.1861 66.4537 81.4039 67.3223 80.3857 67.3757C79.3675 67.4291 78.4988 66.6469 78.4455 65.6287C78.3488 63.7851 80.12 62.3057 80.12 62.3057C80.12 62.3057 82.0361 63.5918 82.1327 65.4354Z",
    fill: "#24284E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0468 65.0722C89.1001 66.0904 88.318 66.959 87.2998 67.0124C86.2816 67.0658 85.4129 66.2836 85.3595 65.2654C85.2629 63.4218 87.0341 61.9424 87.0341 61.9424C87.0341 61.9424 88.9501 63.2285 89.0468 65.0722Z",
    fill: "#24284E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8243 58.4039C92.8868 58.9099 92.4923 59.3458 91.9832 59.3725L68.0161 60.6285C67.507 60.6552 67.0692 60.2629 67.0784 59.7532C67.2002 53.0313 72.5059 47.4524 79.3233 47.0951C86.1408 46.7379 92.0006 51.7315 92.8243 58.4039Z",
    fill: "#24284E"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 77.3828,
    y: 45.3477,
    width: 3.69231,
    height: 3.69231,
    rx: 0.923077,
    transform: "rotate(-3 77.3828 45.3477)",
    fill: "#24284E"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 153.853,
    y: 5.17773,
    width: 48,
    height: 48,
    rx: 24,
    transform: "rotate(2 153.853 5.17773)",
    fill: "#57A1F7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M181.655 42.1702C181.62 43.1891 180.765 43.9863 179.746 43.9508C178.727 43.9152 177.93 43.0603 177.965 42.0413C178.03 40.1963 179.923 38.8769 179.923 38.8769C179.923 38.8769 181.72 40.3251 181.655 42.1702Z",
    fill: "#24284E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M175.197 41.9456C175.162 42.9645 174.307 43.7617 173.288 43.7262C172.269 43.6906 171.472 42.8357 171.507 41.8167C171.572 39.9717 173.465 38.6523 173.465 38.6523C173.465 38.6523 175.262 40.1005 175.197 41.9456Z",
    fill: "#24284E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M171.733 35.3596C171.697 36.3786 170.842 37.1758 169.823 37.1402C168.804 37.1046 168.007 36.2497 168.043 35.2308C168.107 33.3857 170 32.0664 170 32.0664C170 32.0664 171.797 33.5146 171.733 35.3596Z",
    fill: "#24284E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M178.653 35.5998C178.617 36.6188 177.762 37.416 176.743 37.3804C175.724 37.3449 174.927 36.49 174.962 35.471C175.027 33.626 176.92 32.3066 176.92 32.3066C176.92 32.3066 178.717 33.7548 178.653 35.5998Z",
    fill: "#24284E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M185.571 35.842C185.536 36.861 184.681 37.6582 183.662 37.6226C182.643 37.5871 181.846 36.7322 181.881 35.7132C181.946 33.8681 183.839 32.5488 183.839 32.5488C183.839 32.5488 185.636 33.997 185.571 35.842Z",
    fill: "#24284E"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M189.915 29.5282C189.933 30.0377 189.503 30.4376 188.993 30.4198L165.008 29.5822C164.498 29.5644 164.096 29.1354 164.15 28.6285C164.857 21.9427 170.629 16.8475 177.451 17.0858C184.274 17.324 189.676 22.8094 189.915 29.5282Z",
    fill: "#24284E"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 175.671,
    y: 15.1758,
    width: 3.69231,
    height: 3.69231,
    rx: 0.923077,
    transform: "rotate(2 175.671 15.1758)",
    fill: "#24284E"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 192.021,
    y: 26.1152,
    width: 56,
    height: 56,
    rx: 28,
    transform: "rotate(4 192.021 26.1152)",
    fill: "#57A1F7"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M222.932 70.3789C222.849 71.5655 221.82 72.4602 220.633 72.3773C219.446 72.2943 218.552 71.265 218.635 70.0784C218.785 67.9298 221.046 66.4686 221.046 66.4686C221.046 66.4686 223.082 68.2303 222.932 70.3789Z",
    fill: "#24284E"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M215.412 69.8535C215.329 71.0401 214.3 71.9348 213.113 71.8519C211.927 71.7689 211.032 70.7397 211.115 69.553C211.265 67.4044 213.527 65.9432 213.527 65.9432C213.527 65.9432 215.562 67.7049 215.412 69.8535Z",
    fill: "#24284E"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M211.641 62.0332C211.558 63.2198 210.529 64.1145 209.342 64.0316C208.155 63.9486 207.261 62.9193 207.344 61.7327C207.494 59.5841 209.755 58.1229 209.755 58.1229C209.755 58.1229 211.791 59.8846 211.641 62.0332Z",
    fill: "#24284E"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M219.698 62.5957C219.615 63.7823 218.586 64.677 217.399 64.5941C216.213 64.5111 215.318 63.4818 215.401 62.2952C215.551 60.1466 217.813 58.6854 217.813 58.6854C217.813 58.6854 219.849 60.4471 219.698 62.5957Z",
    fill: "#24284E"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M227.755 63.1601C227.672 64.3468 226.643 65.2415 225.456 65.1585C224.269 65.0755 223.375 64.0463 223.458 62.8597C223.608 60.7111 225.869 59.2499 225.869 59.2499C225.869 59.2499 227.905 61.0115 227.755 63.1601Z",
    fill: "#24284E"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M233.078 55.9747C233.078 56.5695 232.559 57.0182 231.966 56.9767L204.034 55.0235C203.441 54.982 202.99 54.4655 203.073 53.8766C204.17 46.1101 211.107 40.4043 219.052 40.9599C226.997 41.5155 233.073 48.1312 233.078 55.9747Z",
    fill: "#24284E"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 217.054,
    y: 38.6602,
    width: 4.30769,
    height: 4.30769,
    rx: 1.07692,
    transform: "rotate(4 217.054 38.6602)",
    fill: "#24284E"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 88.0215,
    y: 63.1152,
    width: 56,
    height: 56,
    rx: 28,
    transform: "rotate(4 88.0215 63.1152)",
    fill: "#57A1F7"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M118.932 107.379C118.849 108.566 117.82 109.46 116.633 109.377C115.446 109.294 114.552 108.265 114.635 107.078C114.785 104.93 117.046 103.469 117.046 103.469C117.046 103.469 119.082 105.23 118.932 107.379Z",
    fill: "#24284E"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M111.412 106.854C111.329 108.04 110.3 108.935 109.113 108.852C107.927 108.769 107.032 107.74 107.115 106.553C107.265 104.404 109.527 102.943 109.527 102.943C109.527 102.943 111.562 104.705 111.412 106.854Z",
    fill: "#24284E"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M107.641 99.0332C107.558 100.22 106.529 101.115 105.342 101.032C104.155 100.949 103.261 99.9193 103.344 98.7327C103.494 96.5841 105.755 95.1229 105.755 95.1229C105.755 95.1229 107.791 96.8846 107.641 99.0332Z",
    fill: "#24284E"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M115.698 99.5957C115.615 100.782 114.586 101.677 113.399 101.594C112.213 101.511 111.318 100.482 111.401 99.2952C111.551 97.1466 113.813 95.6854 113.813 95.6854C113.813 95.6854 115.849 97.4471 115.698 99.5957Z",
    fill: "#24284E"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M123.755 100.16C123.672 101.347 122.643 102.241 121.456 102.159C120.269 102.076 119.375 101.046 119.458 99.8597C119.608 97.7111 121.869 96.2499 121.869 96.2499C121.869 96.2499 123.905 98.0115 123.755 100.16Z",
    fill: "#24284E"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M129.078 92.9747C129.078 93.5695 128.559 94.0182 127.966 93.9767L100.034 92.0235C99.441 91.982 98.9898 91.4655 99.0729 90.8766C100.17 83.1101 107.107 77.4043 115.052 77.9599C122.997 78.5155 129.073 85.1312 129.078 92.9747Z",
    fill: "#24284E"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 113.054,
    y: 75.6602,
    width: 4.30769,
    height: 4.30769,
    rx: 1.07692,
    transform: "rotate(4 113.054 75.6602)",
    fill: "#24284E"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 90.8447,
    y: 5.31055,
    width: 64,
    height: 64,
    rx: 32,
    transform: "rotate(-4 90.8447 5.31055)",
    fill: "#57A1F7"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M132.868 50.4889C132.963 51.8451 131.94 53.0214 130.584 53.1162C129.228 53.211 128.052 52.1885 127.957 50.8324C127.785 48.3768 130.112 46.3634 130.112 46.3634C130.112 46.3634 132.696 48.0334 132.868 50.4889Z",
    fill: "#24284E"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M124.273 51.0905C124.368 52.4467 123.345 53.6229 121.989 53.7178C120.633 53.8126 119.457 52.7901 119.362 51.4339C119.19 48.9784 121.517 46.965 121.517 46.965C121.517 46.965 124.101 48.635 124.273 51.0905Z",
    fill: "#24284E"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M118.761 42.8385C118.856 44.1947 117.834 45.371 116.478 45.4658C115.121 45.5606 113.945 44.5381 113.85 43.182C113.679 40.7264 116.005 38.7131 116.005 38.7131C116.005 38.7131 118.59 40.383 118.761 42.8385Z",
    fill: "#24284E"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M127.969 42.196C128.064 43.5521 127.042 44.7284 125.686 44.8232C124.329 44.9181 123.153 43.8955 123.058 42.5394C122.887 40.0838 125.213 38.0705 125.213 38.0705C125.213 38.0705 127.798 39.7404 127.969 42.196Z",
    fill: "#24284E"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M137.177 41.5514C137.272 42.9076 136.25 44.0839 134.894 44.1787C133.537 44.2735 132.361 43.251 132.266 41.8949C132.095 39.4393 134.421 37.4259 134.421 37.4259C134.421 37.4259 137.006 39.0959 137.177 41.5514Z",
    fill: "#24284E"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M142.059 32.5736C142.154 33.2467 141.638 33.837 140.96 33.8844L109.038 36.1166C108.36 36.164 107.767 35.6512 107.768 34.9715C107.774 26.0075 114.717 18.4467 123.797 17.8117C132.877 17.1768 140.806 23.6976 142.059 32.5736Z",
    fill: "#24284E"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 121.17,
    y: 15.5273,
    width: 4.92308,
    height: 4.92308,
    rx: 1.23077,
    transform: "rotate(-4 121.17 15.5273)",
    fill: "#24284E"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 130.576,
    y: 51.5996,
    width: 72,
    height: 72,
    rx: 36,
    transform: "rotate(-4 130.576 51.5996)",
    fill: "#57A1F7"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M177.852 102.425C177.959 103.95 176.809 105.274 175.283 105.38C173.757 105.487 172.434 104.337 172.327 102.811C172.134 100.048 174.752 97.7834 174.752 97.7834C174.752 97.7834 177.659 99.6621 177.852 102.425Z",
    fill: "#24284E"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M168.183 103.102C168.29 104.628 167.14 105.951 165.614 106.058C164.088 106.165 162.765 105.014 162.658 103.489C162.465 100.726 165.083 98.4611 165.083 98.4611C165.083 98.4611 167.99 100.34 168.183 103.102Z",
    fill: "#24284E"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M161.982 93.8191C162.089 95.3448 160.939 96.6681 159.413 96.7748C157.887 96.8814 156.564 95.7311 156.457 94.2054C156.264 91.443 158.882 89.1779 158.882 89.1779C158.882 89.1779 161.789 91.0566 161.982 93.8191Z",
    fill: "#24284E"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M172.342 93.0964C172.448 94.6221 171.298 95.9454 169.772 96.0521C168.247 96.1588 166.923 95.0085 166.817 93.4828C166.623 90.7203 169.241 88.4553 169.241 88.4553C169.241 88.4553 172.148 90.334 172.342 93.0964Z",
    fill: "#24284E"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M182.701 92.3699C182.808 93.8956 181.657 95.2189 180.132 95.3255C178.606 95.4322 177.283 94.2819 177.176 92.7562C176.983 89.9937 179.6 87.7287 179.6 87.7287C179.6 87.7287 182.508 89.6074 182.701 92.3699Z",
    fill: "#24284E"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M188.191 82.2706C188.298 83.0278 187.718 83.6919 186.955 83.7452L151.043 86.2564C150.28 86.3098 149.613 85.7329 149.614 84.9682C149.62 74.8836 157.432 66.3777 167.647 65.6634C177.862 64.9491 186.781 72.2851 188.191 82.2706Z",
    fill: "#24284E"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 164.692,
    y: 63.0938,
    width: 5.53846,
    height: 5.53846,
    rx: 1.38462,
    transform: "rotate(-4 164.692 63.0938)",
    fill: "#24284E"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64 91C64 89.8954 64.8954 89 66 89H86.2654C87.2607 89 88.1046 89.7319 88.2453 90.7172L91.7547 115.283C91.8954 116.268 92.7393 117 93.7346 117H194.265C195.261 117 196.105 116.268 196.245 115.283L199.755 90.7172C199.895 89.7319 200.739 89 201.735 89H222C223.105 89 224 89.8954 224 91V117V143C224 144.105 223.105 145 222 145H192H96H66C64.8954 145 64 144.105 64 143V117V91Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollectiveContrastShower);
export default __webpack_public_path__ + "static/media/collective-contrast-shower.6bc7478f6295370636d962036cd9bce1.svg";
export { ForwardRef as ReactComponent };